import { render } from "./RegexTester.vue?vue&type=template&id=7fd4428c&scoped=true"
import script from "./RegexTester.vue?vue&type=script&lang=js"
export * from "./RegexTester.vue?vue&type=script&lang=js"

import "./RegexTester.vue?vue&type=style&index=0&id=7fd4428c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd4428c"]])

export default __exports__